"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageUrl = void 0;

var _hubspot = require("hubspot.bender");

var getImageUrl = function getImageUrl(name) {
  var extension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.svg';
  return _hubspot.staticDomainPrefix + "/FileManagerImages/static-1.3073/images/" + name + extension;
};

exports.getImageUrl = getImageUrl;